(function () {
  if (window.__onlyPageBackButtonInit) return;
  window.__onlyPageBackButtonInit = true;

  var INTERNAL_NAV_KEY = 'only_has_internal_nav';

  function getHomeUrl() {
    var config = document.getElementById('page-back-button-config');
    if (!config) return '/';

    try {
      return JSON.parse(config.textContent).homeUrl || '/';
    } catch (e) {
      return '/';
    }
  }

  function markInternalNavigation() {
    try {
      sessionStorage.setItem(INTERNAL_NAV_KEY, '1');
    } catch (e) {}
  }

  function hasInternalBrowsingHistory() {
    try {
      return sessionStorage.getItem(INTERNAL_NAV_KEY) === '1' && window.history.length > 1;
    } catch (e) {
      return window.history.length > 1;
    }
  }

  (function markFromReferrer() {
    if (!document.referrer) return;

    try {
      var cur = new URL(window.location.href);
      var ref = new URL(document.referrer);
      if (ref.origin !== cur.origin) return;
      if (ref.pathname + ref.search !== cur.pathname + cur.search) {
        markInternalNavigation();
      }
    } catch (e) {}
  })();

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || link.target === '_blank') return;

    try {
      var next = new URL(link.href, window.location.origin);
      var cur = new URL(window.location.href);
      if (next.origin !== cur.origin) return;
      if (next.pathname + next.search === cur.pathname + cur.search) return;
      markInternalNavigation();
    } catch (e) {}
  }, true);

  function bindButtons() {
    var homeUrl = getHomeUrl();
    var buttons = document.querySelectorAll('[data-page-back-button]:not([data-page-back-button-bound])');

    buttons.forEach(function (backButton) {
      backButton.setAttribute('data-page-back-button-bound', 'true');

      backButton.addEventListener('click', function () {
        if (hasInternalBrowsingHistory()) {
          window.history.back();
        } else {
          window.location.href = homeUrl;
        }
      });
    });
  }

  function init() {
    bindButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
